import { getRequest } from '../services/requestHandler';
import { ShaftLengthFraction } from '../models';

export const getShaftLengthFraction = async () => {
  const url = 'shaftfraction/GetShaftLengthFraction';
  const response = await getRequest<ShaftLengthFraction>('getShaftLengthFraction', url);
  return response;
};
